import gql from "graphql-tag";

export const GET_TAGS = gql`
    query GetTags($first: Int!, $after: String) {
        tags(first: $first, after:$after){
            edges{
                node{
                    id
                    name
                    usageCount
                }
            }
            pageInfo{
                endCursor
                hasNextPage
            }
        }
    }
`;
